import React, { useState } from 'react';
import GlotioButton from 'components/GlotioComponents/GlotioButton'
import useGlotio from 'hooks/useGlotio'

// styles
import styles from './index.module.scss';

const FullyTranslateLanguagesModal = ({ buttons = [], languages = [] }) => {
  const { translateText } = useGlotio()
  const [isLoading, setIsloading] = useState({});

  const onCallback = (callback, loadingBeforeCallback, buttonIndex) => {
    if (loadingBeforeCallback) {
      setIsloading((prev) => ({ ...prev, [buttonIndex]: true }));
      callback();
      return;
    }
    callback()
  }

  return (
    <>
      <div className={styles.wrapper_title}>
        <p className={styles.title}>{translateText('Fully translate languages')}</p>
        {
          languages.length > 0 &&
          <div className={styles.wrapper_languages}>
            {
              languages.map((lang) => (
                <div key={lang.languageIso} className={styles.language_badge}>
                  <span>{lang.languageName}</span>
                </div>
              ))
            }
          </div>
        }
        <div className={styles.description}>
          {translateText('The languages installed in your online store prior to Glotio will be completely translated again, so you will lose the previous translations. Do you want to integrate the languages to Glotio and translate them again?')}
        </div>
      </div>
      <div className={styles.wrapper_actions}>
        {
          buttons.map(({ text, callback, options, loadingBeforeCallback = false }, index) => (
            <GlotioButton
              isLoading={isLoading[index]}
              key={text}
              {...options}
              onClick={() => onCallback(callback, loadingBeforeCallback, index)}
            >
              {text}
            </GlotioButton>
          ))
        }
      </div>
    </>
  )

}

export default FullyTranslateLanguagesModal
